export const getOptimizedImgUrl = ({ image, quality, ...rest }) => {
  if (!image || !image?.filename) return null

  const imgFilename = image?.filename

  const sbImageServiceUrlIndex = imgFilename.indexOf('/m/')
  const imgSrc =
    sbImageServiceUrlIndex > -1
      ? imgFilename.substring(0, sbImageServiceUrlIndex)
      : imgFilename

  const hostname = new URL(imgSrc).hostname
  const isStoryblokAsset = /^a\.storyblok\.com$/.test(hostname)

  const qualityOptimization = quality && `:quality(${quality})`
  const resizeDimensions = rest.dimensions && `/${rest.dimensions}`
  const additionalFilters =
    rest.filters && rest.filters.map((filter) => `:${filter}`).join('')

  const optimizedImgUrl = `${imgSrc}/m${resizeDimensions || ''}/filters${
    qualityOptimization || ''
  }${additionalFilters || ''}:format(webp)`

  const imgUrl = isStoryblokAsset ? optimizedImgUrl : imgSrc

  return imgUrl
}
